export enum TypeFilterEnum {
    USER_EMAIL = 'userEmail',
    SERVICE_NAME = 'serviceName'
}
